export { ItCallout } from './it-callout.js';
export { ItCalloutMore } from './it-callout-more.js';
export { ItCalloutMoreCollapse } from './it-callout-more-collapse.js';
import '../tslib.es6-Cv888lzs.js';
import '@italia/globals';
import 'lit';
import 'lit/static-html.js';
import 'lit/decorators.js';
import 'lit/directives/class-map.js';
import 'lit/directives/when.js';
import 'lit/directives/if-defined.js';
import '@italia/collapse';

const CALLOUT_VARIANTS = ['primary', 'success', 'warning', 'danger'];

export { CALLOUT_VARIANTS };
//# sourceMappingURL=index.js.map
